import { useSelector } from "react-redux";
import queryString from "query-string";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Form from "./Form";
import { Loader } from "../../../components";
import { useAxios, useComponent } from "../../../hooks";
import {
  createCampaignObject,
  getAudienceDetails,
  objectFromResponse,
} from "../create campaign components/campaign form components/campaignObject";
import {
  brandDetailsObject,
  objectFromBrandResponse,
} from "../brand details components/brandDetailsObject";
import { audienceObject } from "../../audience components/create audience components/audienceObjects";

export default function CampaignRequestDetails() {
  const axios = useAxios();
  const params = useParams();
  const { loader } = useComponent();

  const campaignID = params.campaignID || "";
  const { activeBrand, categories, userID, location, languages } = useSelector(
    (state) => state.memberDetails
  );
  const brandID = queryString.parse(window.location.search).brandID;
  const senderUserID = queryString.parse(window.location.search).sender_id;

  const [icon, setIcon] = useState("");
  const [formData, setFormData] = useState(createCampaignObject);
  const [audienceData, setAudienceData] = useState(audienceObject);
  const [brandDetails, setBrandDetails] = useState({
    data: brandDetailsObject,
    state: false,
  });

  const [takeUpOffer, setTakeUpOffer] = useState({
    state: false,
    action: "",
    data: {
      sender_brandId: parseInt(brandID),
      sender_campaignId: parseInt(campaignID),
      receiver_userId: parseInt(userID),
      receiver_brandId: parseInt(activeBrand.ID),
      dp_note: "",
    },
  });

  useEffect(() => {
    loader.start(4);

    if (!!campaignID) {
      let campaignData = {};
      axios({
        url:
          "/user/brand/getCampaign?brandId=" +
          parseInt(brandID) +
          "&campaignId=" +
          parseInt(campaignID) +
          "&receiverBrandId=" +
          parseInt(activeBrand.ID),
        method: "GET",
      }).then(async (response) => {
        if (response.status) {
          axios({
            url:
              "/brand/promotional/getMappedAudience/?brandId=" +
              activeBrand.ID +
              "&campaignId=" +
              parseInt(campaignID),
          }).then(async (res) => {
            if (res.status) {
              await setAudienceData(getAudienceDetails(res.data));
              loader.apiComplete(1);
            }
          });

          await axios({
            url: "/user/brand/campaign/creatives?campaignId=" + campaignID,
          }).then(async (creatives) => {
            if (creatives.status) {
              campaignData = {
                ...response.data,
                creatives: creatives.data,
              };

              await setFormData(objectFromResponse(campaignData));
              loader.apiComplete(2);
            }
          });
        }
      });

      axios({
        url: "/getBrand/" + brandID,
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          if (!!response.data.logo) {
            setIcon(response.data.logo);
          }
          setBrandDetails({
            data: objectFromBrandResponse(response.data),
            state: false,
          });
          loader.apiComplete();
        }
      });
    } else {
      loader.apiComplete(4);
    }
  }, [
    brandID,
    axios,
    activeBrand.ID,
    userID,
    loader,
    campaignID,
    senderUserID,
  ]);

  return (
    <Loader>
      <Form
        categories={categories}
        location={location}
        languages={languages}
        takeUpOffer={takeUpOffer}
        setTakeUpOffer={setTakeUpOffer}
        formData={formData}
        brandDetails={brandDetails}
        component={"request"}
        setBrandDetails={setBrandDetails}
        audienceData={audienceData}
        icon={icon}
        brandID={brandID}
        campaignID={campaignID}
        userID={userID}
        activeBrand={activeBrand}
      />
    </Loader>
  );
}
